import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  CardMedia,
  Button,
  Link,
  Box
} from '@mui/material'

const styles = {
  instructionBox: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '20px'
  }
}

export const WordPressDealFeed = () => {
  return (
    <Card>
      <CardHeader
        title="WordPress Deal Feed"
        data-testid="wordpress-deal-feed-header"
      />

      <CardContent>
        <Typography variant="body1" gutterBottom>
          A simple WordPress Plugin to showcase top sellings deals, integrated
          natively in your site. Can be customized to fit with the layout and
          style of your brand.
        </Typography>

        <CardMedia sx={{ marginTop: '15px', marginBottom: '15px' }}>
          <img src="assets/images/wordpress-feed.jpg" alt="WordPress example" />
        </CardMedia>

        <Typography variant="h6" gutterBottom>
          Installation Instructions
        </Typography>

        <Box sx={styles.instructionBox}>
          <Typography variant="body1">
            This plugin is ready to be installed from the WordPress plugin
            directory.
          </Typography>

          <Button
            size="small"
            variant="contained"
            href="https://wordpress.org/plugins/stackcommerce-deal-feed/"
            target="_blank"
          >
            Get it
          </Button>
        </Box>

        <Typography variant="body2" gutterBottom>
          Click here for{' '}
          <Link href="pdfs/wp_instructions.pdf" target="_blank">
            instructions on how to set up your WordPress Deal Feed
          </Link>
        </Typography>
      </CardContent>
    </Card>
  )
}
